module.exports = __webpack_public_path__ + "static/media/producer-mic-icon.e1a14424.svg";